export enum CarouselEvents {
  Select = "select",
  SetIndex = "setIndex"
}
